import type { IPagedCollection } from './interfaces/IPagedCollection';

export const pagedQuery = (
  params: {
    pageSize: number;
    pageNo: number;
    orderBy?: string;
    search?: string;
    filters?: string;
  },
  code?: string
): string => {
  const query = new URLSearchParams();
  query.set('pageSize', String(params.pageSize));
  query.set('pageNo', String(params.pageNo));
  if (params.orderBy) query.set('orderBy', params.orderBy);
  if (params.search) query.set('search', params.search);
  if (params.filters) query.set('filters', params.filters);
  if (code) query.set('code', code);
  return query.toString();
};

export const apiCodeQuery = (code?: string) => (code ? `&code=${code}` : '');

export const toPaged = <T>(
  result: unknown,
  pageSize: number,
  pageNo: number
): IPagedCollection<T> => {
  if (Array.isArray(result)) {
    return {
      isLastPage: true,
      items: result,
      pageCount: result.length > 0 ? 1 : 0,
      pageNo,
      pageSize,
      rowsCount: result.length,
    };
  }
  if (
    result &&
    typeof result === 'object' &&
    Array.isArray((result as IPagedCollection<T>).items)
  ) {
    return result as IPagedCollection<T>;
  }
  return {
    isLastPage: true,
    items: [],
    pageCount: 0,
    pageNo,
    pageSize,
    rowsCount: 0,
  };
};
